import type { Review_Slider } from "~/core";

export const isReviewSlider = (item: unknown): item is Review_Slider => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "review_slider"
  );
};
